import DetailedProductPage from './detailedProductPage';
export default DetailedProductPage;
